export default {"src":"/_next/static/media/li-bold.6e132dbd.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};